export const type = ["code", "image", "video"];

export const category = ["html", "css", "javascript"];

export const lessonType = ["content", "quiz", "project"];
